import { createFileRoute } from "@tanstack/react-router";
import { SupporterListPage, modenmisupporterHead } from "@/pages/SupporterListPage";

export const Route = createFileRoute("/mod-en-mi-supporter")({
  head: () => modenmisupporterHead("da"),
  component: () => <SupporterListPage locale="da" />,
});
